import WMSLayer from '@arcgis/core/layers/WMSLayer';
import { GISServiceTypes } from '../gisServicesTypes';
import { ensureLoadedLayerArray, LayerLoader } from './LayerLoader';

export const wmsLayerLoader: LayerLoader = {
  shouldUseLoader(service) {
    return service.service_type == GISServiceTypes.wms;
  },
  async load(service) {
    const layerNames = service?.attributes?.sublayers || [];

    const layer = new WMSLayer({
      id: service.gisLayerID,
      url: service.gis_service_url,
      visible: false,
      sublayers: layerNames.map(name => ({ name })),
    });

    await layer.load();
    return ensureLoadedLayerArray(layer);
  },
};
